import React from 'react';
import {
  Box,
} from '@mui/material';
import { SurveyModel } from 'survey-core';
import { Survey } from 'survey-react-ui';
import 'survey-core/survey-core.min.css';
import { Footer } from '../footer/footer';

interface SurveyPageProps {
  surveyModel: SurveyModel;
  afterQuestions?: React.ReactNode;
}

const SurveyPage: React.FC<SurveyPageProps> = ({
  surveyModel,
  afterQuestions = null,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Survey Questions */}
      <Survey model={surveyModel} />

      { afterQuestions }

      { !surveyModel.showCompletePage &&
      (

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >

          <Box
            style={{
              maxWidth: '50rem',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              margin: '0 auto',
            }}
          >
            <Box
              sx={{
                mt: 2,
                display: 'flex',
                justifyContent: 'center',
                gap: 2,
              }}
            >
              <img
                alt='AICPA'
                src='https://media.creditpulse.com/icons/aicpa_soc_badge.png'
                style={{
                  width: '10%',
                  height: '10%',
                }}
              />
              <img
                alt='SSL'
                src='https://media.creditpulse.com/icons/ssl_badge.png'
                style={{
                  width: '20%',
                  height: '20%',
                }}
              />
            </Box>

            <Box
              sx={{
                mt: 1,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <img
                alt='Credit Pulse Logo'
                src='https://media.creditpulse.com/branding/credit-pulse-banner-logo-transparent.png'
                style={{
                  width: '30%',
                  height: '30%',
                }}
              />
            </Box>
          </Box>
        </Box>
      )}

      <Footer />
    </Box>
  );
};

export default SurveyPage;
